import React from 'react';
import './styles.scss';
import { MyModal } from 'components/Atoms';
import { ListCampaign } from 'components/Organisms';
import { FormattedMessage } from 'react-intl';

const ModalListCampaign = ({ visible, onClose, campaigns = [] }) => {
  return (
    <MyModal
      className="modal-list-campaign "
      visible={visible}
      onClose={onClose}
      title={<FormattedMessage id="modal_list_campaign.list_campaign" defaultMessage="List Campaign" />}
      width={746}
      wrapClassName="modal-center-initial"
    >
      <ListCampaign
        showHeader={false}
        campaigns={campaigns}
        isModal={true}
        showLimit={campaigns.length}
      />
    </MyModal>
  );
};

export default ModalListCampaign;
